import React from 'react'
import { useTranslation } from 'react-i18next'

import { Header } from '../../../../../components/Header'
import { Delete, OpenPreview } from './dialog'

type Props = {
  showActions?: boolean
  isLoading?: boolean
  isTrail: boolean | undefined
}

export const Title: React.FC<Props> = ({ showActions, isLoading, isTrail }) => {
  const { t } = useTranslation()

  const actions =
    showActions && !isLoading ? (
      <>
        <Delete />
        <OpenPreview />
      </>
    ) : undefined

  const title = isTrail
    ? t('eInvoiceDetails.title.title.trail')
    : t('eInvoiceDetails.title.title.title')

  return (
    <Header
      title={title}
      showBackButton
      backUrl="/e-invoices"
      actions={actions}
      isLoading={isLoading}
    />
  )
}
